const content = {
  content_about_us_developer: 'SignalStickerMaker.com (Web), Sigicker(iOS) und SignalSticker Maker(Android) werden entwickelt von: ',
  content_about_us_ads: 'Die Anwendung wird ausschließlich von den Entwicklern finanziert, einschließlich der Kosten für Server-Hosting, Netzwerk, App-Entwicklung und so weiter. Werbung ist der einzige Weg, wie wir versuchen können, die Kosten zu decken. Wir haben bereits die Auswirkungen der Werbung minimiert. Vielen Dank für Ihr Verständnis!',
  faq_question_1: 'Werden meine hochgeladenen Fotos in Ihrer Datenbank gespeichert?',
  faq_answer_1: 'Nein! Alle Bilder werden gelöscht, nachdem das Sticker-Paket erstellt wurde!',
  faq_question_2: 'Kann ich die vorhandenen Sticker-Pakete ändern?',
  faq_answer_2: 'Aufgrund der Einschränkungen von Signal können Sie es nur durch Neuerstellung des gesamten Sticker-Pakets ändern.',
  faq_question_3: 'Wie kann ich Emojis und ein Cover-Bild für mein Sticker-Paket festlegen?',
  faq_answer_3: 'Wir arbeiten daran! Bleiben Sie dran!',
};

const text = {
  text_about_us: 'Über uns',
  text_developers: 'Entwickler',
  text_advertisement: 'Werbung',
  text_image_selected: 'Bild ausgewählt',
  text_image_selected_error: 'Bitte wählen Sie mindestens 1 und höchstens 30 Bilder aus',
  text_maximum: 'Maximum',
  text_supported_format: 'Unterstütztes Format',
  text_field_title: 'Titel',
  text_field_author: 'Autor',
  text_make_your_own_sticker: 'Erstelle deine eigenen Signal Sticker!',
  text_select_images: 'Bilder auswählen',
  text_create_sticker: 'Sticker erstellen',
  text_terms_and_conditions: 'Geschäftsbedingungen',
  text_terms_and_conditions_2: 'Sie erklären hiermit, dass Sie die folgenden gelesen und akzeptiert haben',
  text_optional: 'Optional',
  text_download_now: 'Jetzt herunterladen!',
  text_compability: 'Kompatibilität',
  text_compability_android: 'Android-Gerät mit Android 4.4+',
  text_developed_by: 'Entwickelt mit:',
  text_ssm_on_android: 'SignalStickerMaker auf Android',
  text_android_trade_mark: '"Android", "Android Studio", "Google PlayStore" und ihre Logos sind Markenzeichen von Google LLC.',
  text_ssm_on_ios: 'SignalStickerMaker auf iOS',
  text_compability_ios_1: 'iPhone, iPad, iPod Touch mit iOS 13+',
  text_compability_ios_2: 'Mac mit macOS 11.0+ und Apple M1 Chip',
  text_ssm_trade_mark: 'Apple®, Mac®, Mac OS®, iPhone®, iPad®, iPod touch®, App Store®, Swift®, Xcode® und ihre Logos sind eingetragene Markenzeichen von Apple Inc. in den Vereinigten Staaten und anderen Ländern.',
  text_faq: 'Häufig gestellte Fragen',
  text_stats: 'Statistiken',
  text_statistics: 'Statistiken',
  text_total_sticker_packs: 'Gesamtzahl der erstellten Sticker-Pakete in',
  text_terms_privacy_condition: 'Bedingungen, Datenschutz und Konditionen',
  text_copy_right: 'Urheberrecht',
  text_give_app_a_try_question: 'Möchten Sie unsere App-Version ausprobieren?',
  text_better_experience: 'Bessere Erfahrung',
  text_store_your_sticker: 'Speichern Sie Ihre Sticker',
  text_more_convenient: 'Bequemer',
  text_no_thanks: 'Nein, danke!',
  text_creating_sticker: 'Sticker werden erstellt',
  text_close: 'Schließen',
  text_cancel: 'Abbrechen',
  text_copy_to_clipboard: 'In Zwischenablage kopieren',
  text_copied: 'Kopiert!',
  text_add_sticker_now: 'Sticker jetzt hinzufügen',
  text_try_again: 'Erneut versuchen',
  text_report_to_us: 'Diesen Fehler an uns melden',
  text_reported: 'Gemeldet',
  text_image_converting: 'Bilder werden konvertiert...',
  text_sticker_created_successfully: 'Sticker erfolgreich erstellt!',
  text_service_busy: 'Signal Upload-Service ist ausgelastet, bitte versuchen Sie es in ein paar Stunden erneut!',
  text_upload_failed_try_again: 'Upload fehlgeschlagen, bitte versuchen Sie es später erneut!',
  text_image_uploading: 'Bilder werden hochgeladen...',
  text_step_converting_image: 'Bilder konvertieren',
  text_step_uploading_image: 'Bilder hochladen',
  text_step_result: 'Ergebnis',
  text_educational_title: 'Erstellen Sie professionelle Signal-Sticker-Pakete in Minuten',
  text_educational_description: 'Verwandeln Sie Ihre Bilder mit unserem kostenlosen, benutzerfreundlichen Tool in benutzerdefinierte Signal-Sticker-Pakete. Egal, ob Sie persönliche Sticker für Freunde, Geschäfts-Branding-Materialien oder künstlerische Ausdrücke erstellen, unsere Plattform macht den Prozess einfach und sicher. Keine technischen Kenntnisse erforderlich!',
  text_quick_tips_title: '💡 Schnelle Tipps für bessere Sticker',
  text_tip_1: 'Verwenden Sie hochauflösende Bilder (mindestens 512x512 Pixel) für scharfe Ergebnisse',
  text_tip_2: 'PNG-Format funktioniert am besten für Bilder mit transparenten Hintergründen',
  text_tip_3: 'Halten Sie Designs einfach und erkennbar, wenn sie verkleinert werden',
  text_tip_4: 'Erstellen Sie 10-30 Sticker pro Paket für die beste Vielfalt',
  text_about_signal_title: 'Über Signal',
  text_about_signal_description: 'Signal ist eine auf Privatsphäre fokussierte Messaging-App, die benutzerdefinierte Sticker-Pakete unterstützt. Erstellen und teilen Sie Ihre eigenen einzigartigen Sticker, um Ihre Unterhaltungen persönlicher und unterhaltsamer zu gestalten.',
  text_sticker_guide_card_title: 'Vollständiger Sticker-Leitfaden',
  text_sticker_guide_card_description: 'Lernen Sie bewährte Praktiken, Designprinzipien und Schritt-für-Schritt-Anleitungen für die Erstellung professioneller Signal-Sticker-Pakete.',
  text_image_formats_card_title: 'Bildformat-Leitfaden',
  text_image_formats_card_description: 'Verstehen Sie die Unterschiede zwischen PNG-, WEBP-, JPEG- und GIF-Formaten, um die beste Option für Ihre Sticker zu wählen.',
  text_learn_more: 'Mehr erfahren',
  // Sticker Guide Section - German
  sticker_guide_image_quality_title: 'Sticker-Bildqualitäts-Tipps',
  sticker_guide_image_quality_1: 'Verwenden Sie hochauflösende Bilder (mindestens 512x512 Pixel)',
  sticker_guide_image_quality_2: 'Halten Sie die Bilder scharf, vermeiden Sie Unschärfe',
  sticker_guide_image_quality_3: 'Vermeiden Sie zu starke Komprimierung oder Qualitätsverlust',
  sticker_guide_design_principles_title: 'Designprinzipien',
  sticker_guide_design_principles_1: 'Einfaches, leicht erkennbares Design',
  sticker_guide_design_principles_2: 'Verwenden Sie kräftige Farben und klare Konturen',
  sticker_guide_design_principles_3: 'Sticker sollten auf hellem und dunklem Hintergrund gut sichtbar sein',
  sticker_guide_formats_title: 'Sticker-Formatvergleich',
  sticker_guide_formats_description: 'Signal-Sticker unterstützen PNG, WEBP, JPEG und GIF. Jedes Format hat eigene Vorteile:',
  sticker_guide_png_title: 'PNG (Transparenter Hintergrund)',
  sticker_guide_png_best_for: 'Am besten für Sticker mit transparentem Hintergrund',
  sticker_guide_png_advantages: 'Verlustfreie Komprimierung, hohe Qualität',
  sticker_guide_png_file_size: 'Größere Dateigröße',
  sticker_guide_webp_title: 'WEBP (Effiziente Komprimierung)',
  sticker_guide_webp_best_for: 'Ideal für kleine Dateien mit hoher Qualität',
  sticker_guide_webp_advantages: 'Unterstützt Transparenz, kleine Dateigröße',
  sticker_guide_webp_file_size: 'Kleinste Dateigröße',
  sticker_guide_jpeg_title: 'JPEG (Fotos)',
  sticker_guide_jpeg_best_for: 'Am besten für fotobasierte Sticker',
  sticker_guide_jpeg_advantages: 'Kleine Dateigröße, viele Farben',
  sticker_guide_jpeg_limitations: 'Keine Transparenz, Komprimierung kann Qualität mindern',
  sticker_guide_gif_title: 'GIF (Animation)',
  sticker_guide_gif_best_for: 'Am besten für einfache animierte Sticker',
  sticker_guide_gif_advantages: 'Unterstützt Animationen',
  sticker_guide_gif_limitations: 'Wenige Farben, keine Transparenz',
  sticker_guide_how_to_title: 'So erstellen Sie Signal-Sticker',
  sticker_guide_how_to_description: 'Folgen Sie diesen Schritten, um Sticker zu erstellen:',
  sticker_guide_step_1: 'Wählen Sie die gewünschten Bilder aus',
  sticker_guide_step_2: 'Stellen Sie sicher, dass die Bilder die Qualitätsanforderungen erfüllen',
  sticker_guide_step_3: 'Wählen Sie das passende Format (PNG/WEBP/JPEG/GIF)',
  sticker_guide_step_4: 'Laden Sie die Bilder mit dem Signal Sticker Maker hoch',
  sticker_guide_step_5: 'Sticker ansehen und anpassen',
  sticker_guide_step_6: 'Sticker-Pack herunterladen oder teilen',
  sticker_guide_advanced_tips_title: 'Fortgeschrittene Tipps',
  sticker_guide_advanced_tips_description: 'So werden Ihre Sticker beliebter:',
  sticker_guide_consistency_title: 'Stil-Konsistenz',
  sticker_guide_consistency_description: 'Ein Sticker-Pack sollte einen einheitlichen Stil und ein Thema haben.',
  sticker_guide_emotional_range_title: 'Emotionale Vielfalt',
  sticker_guide_emotional_range_description: 'Erstellen Sie Sticker mit verschiedenen Emotionen und Reaktionen für mehr Abwechslung.',
  sticker_guide_test_others_title: 'Von Freunden testen lassen',
  sticker_guide_test_others_description: 'Lassen Sie Freunde die Sticker ausprobieren und holen Sie Feedback ein.',
  
  // Sticker Guide Page
  sticker_guide_page_title: 'Vollständiger Leitfaden zum Erstellen von Signal-Stickern',
  sticker_guide_page_description: 'Lernen Sie, wie Sie professionelle Signal-Sticker-Pakete mit unserem umfassenden Leitfaden erstellen. Entdecken Sie bewährte Praktiken, Dateiformate, Design-Tipps und Schritt-für-Schritt-Anleitungen.',
  sticker_guide_what_are_title: 'Was sind Signal-Sticker?',
  sticker_guide_what_are_description: 'Signal-Sticker sind benutzerdefinierte Emoticons und Bilder, die Sie in Ihren Signal-Unterhaltungen verwenden können, um Emotionen, Reaktionen und Ideen auszudrücken. Im Gegensatz zu regulären Emojis können Signal-Sticker vollständig angepasst und personalisiert werden, wodurch Sie einzigartige visuelle Kommunikationserfahrungen schaffen können.',
  sticker_guide_why_use_title: 'Warum benutzerdefinierte Sticker verwenden?',
  sticker_guide_why_use_description: 'Benutzerdefinierte Sticker bieten mehrere Vorteile gegenüber Standard-Emojis:',
  sticker_guide_advantage_1: 'Persönlicher Ausdruck: Erstellen Sie Sticker, die Ihre Persönlichkeit, Ihren Humor oder Insider-Witze widerspiegeln',
  sticker_guide_advantage_2: 'Markenidentität: Unternehmen können gebrandete Sticker für Kundenengagement erstellen',
  sticker_guide_advantage_3: 'Kulturelle Relevanz: Erstellen Sie Sticker, die mit Ihrem kulturellen Hintergrund oder Ihrer Gemeinschaft in Resonanz stehen',
  sticker_guide_advantage_4: 'Einprägsame Kommunikation: Stechen Sie in Unterhaltungen mit einzigartigen visuellen Elementen hervor',
  sticker_guide_best_practices_title: 'Bewährte Praktiken für die Sticker-Erstellung',
  sticker_guide_best_practices_description: 'Um effektive und ansprechende Sticker zu erstellen, befolgen Sie diese Richtlinien:',
  sticker_guide_ready_title: 'Bereit, Ihre eigenen Sticker zu erstellen?',
  sticker_guide_ready_description: 'Jetzt, da Sie die Grundlagen der Sticker-Erstellung verstehen, sind Sie bereit, Ihre Ideen zum Leben zu erwecken! Verwenden Sie unseren kostenlosen Signal-Sticker-Maker, um Ihre Bilder in ein professionelles Sticker-Paket zu verwandeln, das Sie mit Freunden, Familie oder der gesamten Signal-Community teilen können.',
  
  // Image Formats Page
  image_formats_page_title: 'Bildformate verstehen: Ein vollständiger Leitfaden',
  image_formats_page_description: 'In der heutigen digitalen Welt kann die Wahl des richtigen Bildformats die Leistung Ihrer Website, die Benutzererfahrung und die visuelle Qualität erheblich beeinflussen. Egal, ob Sie Sticker erstellen, eine Website bauen oder Fotos teilen, das Verständnis der Unterschiede zwischen Bildformaten ist entscheidend für fundierte Entscheidungen.',
  image_formats_what_are_title: 'Was sind Bildformate?',
  image_formats_what_are_description: 'Bildformate sind standardisierte Wege zur Organisation und Speicherung digitaler Bilddaten. Jedes Format verwendet verschiedene Komprimierungsalgorithmen, Farbdarstellungen und Funktionssets, um Dateigröße, Qualität und Funktionalität auszubalancieren. Die Wahl des Formats hängt von Ihren spezifischen Bedürfnissen ab: Web-Performance, Druckqualität, Transparenz-Unterstützung oder Animationsfähigkeiten.',
  image_formats_comparison_title: 'Detaillierter Format-Vergleich',
  image_formats_future_title: 'Zukunft der Bildformate',
  image_formats_future_description: 'Die Bildformat-Landschaft entwickelt sich weiter mit neuen Technologien:',
  
  // PNG Section
  image_formats_png_title: 'PNG (Portable Network Graphics)',
  image_formats_png_description: 'PNG ist ein verlustfreies Komprimierungsformat, das zum Standard für Webgrafiken mit Transparenz geworden ist.',
  image_formats_png_features_title: 'Hauptmerkmale:',
  image_formats_png_feature_1: 'Verlustfreie Komprimierung - keine Qualitätsverschlechterung',
  image_formats_png_feature_2: 'Vollständige Alpha-Kanal-Transparenz-Unterstützung',
  image_formats_png_feature_3: 'Unterstützt bis zu 16,7 Millionen Farben',
  image_formats_png_feature_4: 'Ausgezeichnet für Grafiken mit scharfen Kanten und Text',
  image_formats_png_uses_title: 'Beste Anwendungsfälle:',
  image_formats_png_use_1: 'Website-Logos und Symbole',
  image_formats_png_use_2: 'Screenshots und Benutzeroberflächenelemente',
  image_formats_png_use_3: 'Bilder mit transparentem Hintergrund',
  image_formats_png_use_4: 'Grafiken mit Textüberlagerungen',
  image_formats_png_limitations_title: 'Einschränkungen:',
  image_formats_png_limitations: 'Größere Dateigrößen im Vergleich zu verlustbehafteten Formaten, weniger geeignet für große fotografische Bilder, bei denen die Dateigröße ein Problem darstellt.',

  // WEBP Section
  image_formats_webp_title: 'WEBP (Web Picture Format)',
  image_formats_webp_description: 'Von Google entwickelt, ist WEBP ein modernes Bildformat, das überlegene Komprimierung bei hoher Qualität bietet.',
  image_formats_webp_features_title: 'Hauptmerkmale:',
  image_formats_webp_feature_1: '25-35% kleinere Dateigrößen als PNG',
  image_formats_webp_feature_2: 'Unterstützt sowohl verlustbehaftete als auch verlustfreie Komprimierung',
  image_formats_webp_feature_3: 'Alpha-Kanal-Transparenz-Unterstützung',
  image_formats_webp_feature_4: 'Animations-Unterstützung (besser als GIF)',
  image_formats_webp_uses_title: 'Beste Anwendungsfälle:',
  image_formats_webp_use_1: 'Moderne Webanwendungen',
  image_formats_webp_use_2: 'Mobile App-Assets',
  image_formats_webp_use_3: 'E-Commerce-Produktbilder',
  image_formats_webp_use_4: 'Jedes Szenario, in dem die Dateigröße wichtig ist',
  image_formats_webp_limitations_title: 'Einschränkungen:',
  image_formats_webp_limitations: 'Begrenzte Unterstützung in älteren Browsern (obwohl dies weniger problematisch wird). Einige Bildbearbeitungssoftware unterstützt möglicherweise nicht vollständig die WEBP-Bearbeitung.',

  // JPEG Section
  image_formats_jpeg_title: 'JPEG (Joint Photographic Experts Group)',
  image_formats_jpeg_description: 'JPEG ist das am weitesten verbreitete Format für fotografische Bilder und bietet ausgezeichnete Komprimierung für komplexe Bilder.',
  image_formats_jpeg_features_title: 'Hauptmerkmale:',
  image_formats_jpeg_feature_1: 'Ausgezeichnete Komprimierung für Fotografien',
  image_formats_jpeg_feature_2: 'Kleine Dateigrößen ideal für Web-Nutzung',
  image_formats_jpeg_feature_3: 'Universelle Browser- und Geräte-Unterstützung',
  image_formats_jpeg_feature_4: 'Anpassbare Qualitätseinstellungen',
  image_formats_jpeg_uses_title: 'Beste Anwendungsfälle:',
  image_formats_jpeg_use_1: 'Digitale Fotografie',
  image_formats_jpeg_use_2: 'Social Media Bildaustausch',
  image_formats_jpeg_use_3: 'Website-Heldenbilder und Galerien',
  image_formats_jpeg_use_4: 'E-Mail-Anhänge',
  image_formats_jpeg_limitations_title: 'Einschränkungen:',
  image_formats_jpeg_limitations: 'Verlustbehaftete Komprimierung kann die Qualität bei wiederholter Bearbeitung verschlechtern. Keine Transparenz-Unterstützung. Schlechte Leistung bei Grafiken mit scharfen Kanten oder Text.',

  // GIF Section
  image_formats_gif_title: 'GIF (Graphics Interchange Format)',
  image_formats_gif_description: 'Obwohl es eines der ältesten Webformate ist, bleibt GIF für einfache Animationen und Grafiken beliebt.',
  image_formats_gif_features_title: 'Hauptmerkmale:',
  image_formats_gif_feature_1: 'Animations-Unterstützung',
  image_formats_gif_feature_2: 'Einfarbige Transparenz',
  image_formats_gif_feature_3: 'Verlustfreie Komprimierung für einfache Grafiken',
  image_formats_gif_feature_4: 'Universelle Unterstützung auf allen Plattformen',
  image_formats_gif_uses_title: 'Beste Anwendungsfälle:',
  image_formats_gif_use_1: 'Einfache Animationen und Memes',
  image_formats_gif_use_2: 'Ladeindikatoren und UI-Animationen',
  image_formats_gif_use_3: 'Einfache Grafiken mit wenigen Farben',
  image_formats_gif_use_4: 'Pixel-Art und Retro-Stil-Grafiken',
  image_formats_gif_limitations_title: 'Einschränkungen:',
  image_formats_gif_limitations: 'Begrenzt auf 256 Farben, ungeeignet für hochwertige Fotografie. Große Dateigrößen für komplexe Animationen. Keine Alpha-Transparenz-Unterstützung.',

  // Decision Matrix Section
  image_formats_decision_matrix_title: 'Das richtige Format wählen: Entscheidungsmatrix',
  image_formats_decision_guide: 'Schneller Entscheidungsleitfaden:',
  image_formats_transparency_title: 'Für Transparenz',
  image_formats_transparency_best: 'Beste: PNG, WEBP',
  image_formats_transparency_avoid: 'Vermeiden: JPEG',
  image_formats_photography_title: 'Für Fotografie',
  image_formats_photography_best: 'Beste: JPEG, WEBP',
  image_formats_photography_avoid: 'Vermeiden: GIF',
  image_formats_animation_title: 'Für Animation',
  image_formats_animation_best: 'Beste: WEBP, GIF',
  image_formats_animation_avoid: 'Vermeiden: JPEG, PNG',
  image_formats_filesize_title: 'Für Dateigröße',
  image_formats_filesize_best: 'Beste: WEBP, JPEG',
  image_formats_filesize_largest: 'Größte: PNG',

  // Technical Specifications
  image_formats_tech_specs_title: 'Technische Spezifikationen Vergleich',
  image_formats_tech_feature: 'Merkmal',
  image_formats_tech_compression: 'Komprimierungstyp',
  image_formats_tech_transparency: 'Transparenz',
  image_formats_tech_animation: 'Animation',
  image_formats_tech_colors: 'Max Farben',
  image_formats_tech_browser: 'Browser-Unterstützung',
  image_formats_tech_lossless: 'Verlustfrei',
  image_formats_tech_both: 'Beide',
  image_formats_tech_lossy: 'Verlustbehaftet',
  image_formats_tech_alpha: 'Alpha-Kanal',
  image_formats_tech_no: 'Nein',
  image_formats_tech_binary: 'Binär',
  image_formats_tech_yes: 'Ja',
  image_formats_tech_colors_full: '16,7M',
  image_formats_tech_colors_limited: '256',
  image_formats_tech_universal: 'Universal',
  image_formats_tech_modern: 'Modern',

  // Performance Section
  image_formats_performance_title: 'Leistungsauswirkungen auf Websites',
  image_formats_performance_description: 'Die Wahl des Bildformats beeinflusst die Website-Performance erheblich, was sich direkt auf die Benutzererfahrung und SEO-Rankings auswirkt:',
  image_formats_loading_title: 'Ladegeschwindigkeit',
  image_formats_loading_description: 'Kleinere Dateigrößen (WEBP, optimiertes JPEG) führen zu schnelleren Seitenladezeiten, was für die Benutzerbindung und SEO entscheidend ist. Eine 1-Sekunden-Verzögerung bei der Seitenladezeit kann Konversionen um 7% reduzieren.',
  image_formats_mobile_title: 'Mobile Erfahrung',
  image_formats_mobile_description: 'Auf mobilen Geräten mit begrenzter Bandbreite kann die Wahl effizienter Formate wie WEBP die Benutzererfahrung dramatisch verbessern. Mobile Benutzer erwarten, dass Seiten in unter 3 Sekunden laden.',
  image_formats_seo_title: 'SEO-Vorteile',
  image_formats_seo_description: 'Google betrachtet Seitengeschwindigkeit als Ranking-Faktor. Optimierte Bilder tragen zu besseren Core Web Vitals-Scores bei und verbessern möglicherweise Ihre Suchmaschinen-Rankings.',

  // Future Section
  image_formats_future_avif: 'AVIF: Neueres Format mit noch besserer Komprimierung als WEBP, gewinnt langsam Browser-Unterstützung',
  image_formats_future_heif: 'HEIF: Apples bevorzugtes Format für iOS-Geräte, ausgezeichnete Komprimierung aber begrenzte Web-Unterstützung',
  image_formats_future_svg: 'SVG: Vektorformat perfekt für skalierbare Grafiken und Symbole',

  // Conclusion
  image_formats_conclusion_title: 'Bereit, Ihre Bilder zu optimieren?',
  image_formats_conclusion_description: 'Jetzt, da Sie die Stärken und Schwächen jedes Bildformats verstehen, können Sie fundierte Entscheidungen für Ihre Projekte treffen. Ob Sie Signal-Sticker erstellen, eine Website aufbauen oder Inhalte online teilen, die Wahl des richtigen Formats gewährleistet die beste Balance aus Qualität, Leistung und Kompatibilität für Ihre spezifischen Bedürfnisse.',
};

const language_spec = {
  lang_code: 'de',
  name: 'Deutsch',
  flag: '🇩🇪',
};

const menu_items = {
  menu_item_ios: 'iOS',
  menu_item_android: 'Android',
  menu_item_faq: 'FAQ',
  menu_item_about_us: 'Über uns',
  menu_item_support: 'Support',
  menu_item_create_stickers: 'Sticker erstellen',
  menu_item_sticker_guide: 'Sticker-Leitfaden',
  menu_item_image_formats: 'Bildformate',
};

const seo = {
  seo_default_title: 'Signal Sticker Maker - Erstellen Sie Ihre eigenen Sticker',
  seo_default_description: 'Kostenloser Signal Sticker Maker - Erstellen Sie benutzerdefinierte Sticker für die Signal Messaging-App in Minuten. Erstellen Sie personalisierte Stickerpakete mit unserem benutzerfreundlichen Online-Tool. Keine Software erforderlich, funktioniert auf Mobilgeräten und Desktop.',
  seo_support_title: 'Support',
  seo_support_description: 'Kontaktieren Sie uns für Support',
  seo_ios_description: 'Die SignalStickerMaker.com iOS App ist jetzt im App Store verfügbar!',
  seo_android_description: 'Die SignalStickerMaker.com Android App ist jetzt im Google Play Store verfügbar!',
  seo_about_us_description: 'Die Geschichte von SignalStickerMaker.com',
  seo_faq_title: 'FAQ',
  seo_faq_description: 'Durchsuchen Sie die häufig gestellten Fragen',
  seo_title_support: 'Support',
  seo_title_support_description: 'Kontaktieren Sie uns für Support und Hilfe',
  canvas: 'Leinwand',
  stickerCount: 'Sticker-Anzahl',
  about_us_mission_title: 'Unsere Mission',
  about_us_mission_content: 'Bei Signal Sticker Maker glauben wir, dass Kommunikation persönlich, spaßig und kreativ sein sollte. Unsere Mission ist es, die Sticker-Erstellung zu demokratisieren und es jedem zu ermöglichen, sich durch benutzerdefinierte Signal-Sticker auszudrücken. Ob Sie Insider-Witze mit Freunden teilen, eine Markenidentität für Ihr Unternehmen aufbauen oder einfach nur etwas Persönlichkeit in Ihre Gespräche bringen möchten, wir stellen die Werkzeuge zur Verfügung - völlig kostenlos.',
  about_us_why_built_title: 'Warum wir das gebaut haben',
  about_us_why_built_content: 'Die Idee für Signal Sticker Maker entstand aus unserer eigenen Frustration über die begrenzten Möglichkeiten zur Erstellung benutzerdefinierter Sticker. Wir wollten ein einfaches, zugängliches Tool, das keine technischen Kenntnisse oder teure Software erfordert. Das treibt uns an:',
  about_us_accessibility: 'Zugänglichkeit: Jeder sollte benutzerdefinierte Sticker erstellen können, unabhängig von technischen Fähigkeiten',
  about_us_privacy: 'Datenschutz: Ihre Bilder werden sicher verarbeitet und niemals auf unseren Servern gespeichert',
  about_us_simplicity: 'Einfachheit: Der Erstellungsprozess sollte Minuten dauern, nicht Stunden',
  about_us_quality: 'Qualität: Die resultierenden Sticker sollten hochwertig und Signal-kompatibel sein',
  about_us_team_description: 'Unser Team kombiniert Expertise in Webentwicklung, User Experience Design und mobilen Anwendungen, um Tools zu schaffen, die sowohl mächtig als auch einfach zu bedienen sind. Wir sind leidenschaftlich für Open-Source-Technologie und glauben daran, Produkte zu entwickeln, die die Privatsphäre der Nutzer respektieren und gleichzeitig außerordentliche Funktionalität bieten.',
  about_us_tech_stack_title: 'Unser Technologie-Stack',
  about_us_tech_stack_description: 'Wir haben Signal Sticker Maker mit modernen Webtechnologien entwickelt, um Zuverlässigkeit, Geschwindigkeit und Sicherheit zu gewährleisten:',
  about_us_frontend_title: 'Frontend',
  about_us_frontend_description: 'React.js mit TypeScript für eine responsive, typsichere Benutzeroberfläche',
  about_us_backend_title: 'Backend',
  about_us_backend_description: 'AWS Lambda für serverlose Verarbeitung und S3 für sichere Dateiverwaltung',
  about_us_security_title: 'Sicherheit',
  about_us_security_description: 'Ende-zu-Ende-Verschlüsselung und automatische Dateilöschung für maximale Privatsphäre',
  about_us_privacy_security_title: 'Datenschutz und Sicherheit',
  about_us_privacy_security_description: 'Ihre Privatsphäre hat für uns oberste Priorität. So schützen wir Ihre Daten:',
  about_us_privacy_point_1: 'Bilder werden wann immer möglich clientseitig verarbeitet',
  about_us_privacy_point_2: 'Hochgeladene Dateien werden nach der Verarbeitung automatisch gelöscht',
  about_us_privacy_point_3: 'Wir verfolgen keine persönlichen Informationen oder speichern Benutzerdaten',
  about_us_privacy_point_4: 'Alle Kommunikationen sind mit branchenstandard Protokollen verschlüsselt',
  about_us_community_title: 'Community-Einfluss',
  about_us_community_description: 'Seit dem Start hat Signal Sticker Maker Tausenden von Nutzern geholfen, benutzerdefinierte Sticker-Pakete zu erstellen. Wir haben erstaunliche Kreativität von unserer Community gesehen - von persönlichen Familien-Stickern bis hin zu Geschäftswerbematerialien, Bildungsressourcen und künstlerischem Ausdruck. Jedes erstellte Sticker-Paket repräsentiert jemandes einzigartige Stimme in der digitalen Kommunikation.',
  about_us_ads_description: 'Der Betrieb eines kostenlosen Dienstes erfordert nachhaltige Finanzierung. Wir verwenden ethische Werbepraktiken und arbeiten nur mit relevanten, hochwertigen Werbetreibenden zusammen. Werbeeinnahmen helfen uns, unsere Server zu warten, neue Funktionen zu entwickeln und den Service für alle kostenlos zu halten. Wir verpflichten uns, niemals die Benutzererfahrung oder Privatsphäre für Werbeeinnahmen zu kompromittieren.',
  about_us_future_title: 'Zukunftspläne',
  about_us_future_description: 'Wir arbeiten ständig daran, Signal Sticker Maker zu verbessern. Das planen wir:',
  about_us_future_point_1: 'Erweiterte Bearbeitungstools zur Feinabstimmung von Stickern',
  about_us_future_point_2: 'Stapelverarbeitung zur effizienten Erstellung mehrerer Pakete',
  about_us_future_point_3: 'Vorlagenbibliothek für schnelle Sticker-Erstellung',
  about_us_future_point_4: 'Integration mit anderen Messaging-Plattformen',
  about_us_contact_title: 'Kontakt aufnehmen',
  about_us_contact_description: 'Wir hören gerne von unseren Nutzern! Ob Sie Feedback, Vorschläge haben oder einfach nur Ihre tollen Sticker-Kreationen teilen möchten, zögern Sie nicht, uns zu kontaktieren. Ihr Input hilft uns, ein besseres Tool für alle zu entwickeln.',
  faq_intro: 'Willkommen in unserem umfassenden FAQ-Bereich! Hier finden Sie Antworten auf die häufigsten Fragen zur Erstellung benutzerdefinierter Signal-Sticker, zur Verwendung unseres Signal-Sticker-Makers, zu Bildformaten, Design-Best-Practices und zur Fehlerbehebung. Egal, ob Sie neu in der Erstellung benutzerdefinierter Sticker sind oder Ihre Fähigkeiten in der Messaging-App-Sticker-Erstellung perfektionieren möchten, dieser Leitfaden hilft Ihnen weiter.',
  faq_question_4: 'Welche Bildformate werden unterstützt?',
  faq_answer_4: 'Wir unterstützen PNG-, JPEG-, WEBP- und GIF-Formate. PNG wird für Bilder mit Transparenz empfohlen, JPEG für Fotografien, WEBP für optimale Dateigröße und GIF für einfache Animationen. Jedes Format hat je nach Anwendungsfall seine eigenen Stärken.',
  faq_question_5: 'Was ist die empfohlene Bildgröße für Sticker?',
  faq_answer_5: 'Für beste Ergebnisse verwenden Sie Bilder mit mindestens 512x512 Pixeln. Dies stellt sicher, dass Ihre Sticker auf allen Geräten scharf aussehen. Die maximal empfohlene Größe beträgt 1024x1024 Pixel, um Qualität und Dateigröße auszubalancieren.',
  faq_question_6: 'Wie viele Sticker kann ich in ein Paket einfügen?',
  faq_answer_6: 'Sie können Sticker-Pakete mit 3 bis 150 Stickern erstellen. Wir empfehlen, mit 10-30 Stickern zu beginnen, um eine gute Vielfalt zu gewährleisten und das Paket überschaubar zu halten. Beliebte Pakete haben typischerweise 15-25 Sticker, die verschiedene Emotionen und Situationen abdecken.',
  faq_question_7: 'Werden meine Bilder auf Ihren Servern gespeichert?',
  faq_answer_7: 'Nein, wir priorisieren Ihre Privatsphäre. Bilder werden vorübergehend verarbeitet und automatisch gelöscht, nachdem Ihr Sticker-Paket erstellt wurde. Wir speichern keine Ihrer persönlichen Bilder oder Daten auf unseren Servern.',
  faq_question_8: 'Kann ich animierte Sticker erstellen?',
  faq_answer_8: 'Ja! Sie können GIF-Dateien hochladen, um animierte Sticker zu erstellen. Beachten Sie, dass animierte Sticker einfach und nicht zu lang sein sollten, um eine gute Leistung auf verschiedenen Geräten zu gewährleisten.',
  faq_question_9: 'Demnächst',
  faq_answer_9: 'Demnächst',
  faq_question_10: 'Demnächst',
  faq_answer_10: 'Demnächst',
  faq_question_11: 'Demnächst',
  faq_answer_11: 'Demnächst',
  faq_question_12: 'Demnächst',
  faq_answer_12: 'Demnächst',
  faq_question_13: 'Demnächst',
  faq_answer_13: 'Demnächst',
  faq_question_14: 'Demnächst',
  faq_answer_14: 'Demnächst',
  faq_question_15: 'Demnächst',
  faq_answer_15: 'Demnächst',
  faq_question_16: 'Demnächst',
  faq_answer_16: 'Demnächst',
  faq_question_17: 'Demnächst',
  faq_answer_17: 'Demnächst',
  faq_question_18: 'Demnächst',
  faq_answer_18: 'Demnächst',
  faq_still_questions_title: 'Haben Sie noch Fragen?',
  faq_still_questions_description: 'Wenn Sie die gesuchte Antwort nicht finden können, zögern Sie nicht, uns für weitere Hilfe zu kontaktieren.',
  faq_guides_description: 'Schauen Sie sich unsere detaillierten Leitfäden für Schritt-für-Schritt-Anleitungen zur Erstellung perfekter Signal-Sticker an.',
};

const error = {
  error_file_size_title: 'Bilder überschreiten maximale Dateigröße',
  error_file_size: 'Die Bilddateigröße überschritt nach der Komprimierung 10 MB. Bitte begrenzen Sie Ihre Bilddateigröße vor dem Hochladen weiter.',
  error_conversion: 'Die Bildkonvertierung ist fehlgeschlagen. Bitte versuchen Sie es mit anderen Browsern und/oder auf Computern.'
};

const translation = {
  ...language_spec,
  ...content,
  ...text,
  ...menu_items,
  ...seo,
  ...error,
};

export default translation;